import type { Action, LiabilityType, LoanType } from '../../types';

export const getCommandName = ({
    action,
    loanType,
}: {
    action: Action;
    loanType: LoanType;
}): `${Action}${LiabilityType}` => {
    let suffix: LiabilityType;
    switch (loanType) {
        case 'ratenkredite':
            suffix = 'LiabilityInstallmentCredit';
            break;
        case 'geschaeftskredite':
            suffix = 'LiabilityBusinessCredit';
            break;
        case 'kreditkarten':
            suffix = 'LiabilityCreditCard';
            break;
        case 'dispositionskredite':
            suffix = 'LiabilityOverdraft';
            break;
        case 'sonstigeVerbindlichkeiten':
            suffix = 'LiabilityOther';
            break;
        case 'leasings':
            suffix = 'LiabilityLeasing';
            break;
        case 'kontokorrentkredite':
            suffix = 'LiabilityOverdraftBusiness';
            break;
        case 'immobiliendarlehen':
            suffix = 'LiabilityRealEstateLoan';
            break;
        default:
            throw new Error(`Invalid loan type: ${loanType}`);
    }
    return `${action}${suffix}`;
};
